/**
 * Trims trailing fraction zeros from an already-formatted string, keeping at
 * least `minDecimals` digits. Pure string work, so grouped or decorated text
 * passes through unparsed.
 */
export function trimDisplayZeros(str: string, minDecimals = 1): string {
	if (!str.includes('.')) return str;
	const sides = str.split('.');
	sides[1] = sides[1].replace(/0+$/, '').padEnd(minDecimals, '0');
	return sides[1].length === 0 ? sides[0] : sides.join('.');
}
